import React from "react";
import { Badge } from "@/components/ui/badge";
import { statusClass, statusLabel } from "@/lib/api";

export default function StatusBadge({ status }) {
  return (
    <Badge className={`${statusClass(status)} border font-bold`}>
      {statusLabel(status)}
    </Badge>
  );
}
